// URL-State parser für `?status=` Filter (LibraryPage). Whitelist-validation
// + Default-Fallback für graceful URL-Tampering. Mirror des server-side
// Zod-`.catch()`-Pattern.
//
// Sprint Quick-Wins Item 2.

import {
  ASSET_STATUS_FILTERS,
  type AssetStatusFilter,
} from '../../shared/asset-constants.js';

const VALID = new Set<string>(ASSET_STATUS_FILTERS);

export function parseStatus(raw: string | null | undefined): AssetStatusFilter {
  if (raw == null) return 'approved';
  return VALID.has(raw) ? (raw as AssetStatusFilter) : 'approved';
}
